import PropTypes from "prop-types";
import { useSnackbar } from "notistack";
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { isNull } from "lodash";

const customerContactDummy = [];
export const EmployeeProfileContext = createContext(null);

export const EmployeeProfileProvider = ({ children }) => {
  const [list, setList] = useState(customerContactDummy);
  const [reviews, setReviews] = useState([]);
  const [permits, setPermits] = useState([]);
  const [guardCard, setGuardCards] = useState([]);
  const [businessUnits, setBusinessUnits] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [employeeRecord, setEmployeeRecord] = useState({});
  const [permitsDetails, setPermitsDetails] = useState();
  const [open, setOpen] = useState(false);
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [formRecord, setFormRecord] = useState();
  const [users, setUsers] = useState([]);
  const [isEditable, setIsEditable] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [signee, setSignee] = useState([]);
  const [form, setForm] = useState("");
  const [permitsList, setPermitsList] = useState([]);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setIsLoading(true);
    const dataArr = [...list];
    const [removed] = dataArr.splice(oldIndex, 1);
    dataArr.splice(newIndex, 0, removed);
    console.log("dataArr", dataArr);
    setTimeout(() => {
      setIsLoading(false);
    }, 300);
    return setList(dataArr);
  };

  function addAfter(array, index, newItem) {
    return [...array.slice(0, index), newItem, ...array.slice(index)];
  }

  const addToList = (num, action) => {
    console.log("0", num, action);
    let newData = null;
    if (action === "add") {
      const id = list.length + 1;
      const newRecord = {
        id: id,
        name: "Mark " + id,
        position: "Guard " + id,
        contact: "1234456 " + id,
        email: "mark@ascendware.net " + id,
        isPrimary: false,
        isEmergency: false,
      };
      newData = addAfter(list, num + 1, newRecord);
    }
    if (action === "remove") {
      newData = list.filter((_, index) => index !== num);
    }

    console.log("newData", num, action, newData);
    return setList(newData);
  };

  const memoizedValue = useMemo(
    () => ({
      list,
      setList,
      addToList,
      onSortEnd,
      isLoading,
      employeeRecord,
      setEmployeeRecord,
      reviews,
      setReviews,
      permits,
      setPermits,
      guardCard,
      setGuardCards,
      businessUnits,
      setBusinessUnits,
      permitsDetails,
      setPermitsDetails,
      open,
      setOpen,
      isOpenDialog,
      setIsOpenDialog,
      formRecord,
      setFormRecord,
      users,
      setUsers,
      isEditable,
      setIsEditable,
      signee,
      setSignee,
      form,
      setForm,
      isCompleted,
      setIsCompleted,
      permitsList,
      setPermitsList,
    }),
    [
      list,
      setList,
      addToList,
      onSortEnd,
      isLoading,
      employeeRecord,
      reviews,
      permits,
      guardCard,
      businessUnits,
      permitsDetails,
      open,
      isOpenDialog,
      formRecord,
      users,
      isEditable,
      signee,
      form,
      isCompleted,
      permitsList,
    ]
  );
  return (
    <EmployeeProfileContext.Provider value={memoizedValue}>
      {children}
    </EmployeeProfileContext.Provider>
  );
};

export const useEmployeeProfileContext = () => {
  const context = useContext(EmployeeProfileContext);

  if (!context)
    throw new Error(
      "useEmployeeProfileContext context must be use inside EmployeeProfileProvider"
    );

  return context;
};

EmployeeProfileProvider.propType = {
  children: PropTypes.node,
};

// ----------------------------------------------------------------------
